import {IMAGE_ASSET} from 'consts'
import {REDUX_STORE, reduxUpdateDispatcher} from 'lib/redux'

export function getDefaultAvatar() {
  return IMAGE_ASSET('giftshop', 'users/default-portrait.png')
}

export function getChildrenStatus() {
  const {age_group} = REDUX_STORE.getState().user || {}
  const {creatorStatus} = REDUX_STORE.getState().yuserActivationState || {}
  const {status} = REDUX_STORE.getState().parentalConsentState

  if (!age_group) return

  if (age_group === 'adult' || creatorStatus === 'verified') {
    if (status) {
      reduxUpdateDispatcher('parentalConsentState', {status: undefined})
    }
    return
  }

  const newStatus = age_group === 'child' ? 'UNDERAGE' : 'TEEN'
  if (status !== newStatus) {
    reduxUpdateDispatcher('parentalConsentState', {status: newStatus})
  }
}
